import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";

export default function Account() {
  const { user } = useAuth();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) {
      toast.error("New password and confirmation do not match");
      return;
    }
    if (form.new_password.length < 8) {
      toast.error("New password must be at least 8 characters");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/change-password", {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      toast.success("Password updated successfully");
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full border border-slate-300 px-4 py-3 text-sm focus:outline-none focus:border-[#0F2C59]";

  return (
    <div className="max-w-md">
      <h1 className="font-serif-display text-2xl font-bold text-[#111827] mb-1">Account</h1>
      <p className="text-sm text-slate-500 mb-6">Signed in as {user?.email}</p>

      <div className="border border-slate-200 bg-white p-6">
        <h2 className="font-semibold text-slate-700 mb-4">Change Password</h2>
        <form onSubmit={submit} data-testid="change-password-form" className="space-y-4">
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1">Current password</label>
            <input data-testid="cp-current" type="password" required value={form.current_password}
              onChange={(e) => setForm({ ...form, current_password: e.target.value })} className={inputCls} />
          </div>
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1">New password</label>
            <input data-testid="cp-new" type="password" required value={form.new_password}
              onChange={(e) => setForm({ ...form, new_password: e.target.value })} className={inputCls} />
            <p className="text-xs text-slate-400 mt-1">At least 8 characters.</p>
          </div>
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1">Confirm new password</label>
            <input data-testid="cp-confirm" type="password" required value={form.confirm}
              onChange={(e) => setForm({ ...form, confirm: e.target.value })} className={inputCls} />
          </div>
          <button data-testid="cp-submit" type="submit" disabled={loading}
            className="bg-[#0F2C59] text-white px-6 py-2.5 text-sm font-semibold hover:bg-[#174082] disabled:opacity-50">
            {loading ? "Updating…" : "Update Password"}
          </button>
        </form>
      </div>
    </div>
  );
}
